import { apiInitialState } from '../../../utils/apiStateUtils';

export default{
    topResultsApi: apiInitialState()
};